import React from 'react';
import { useTranslation } from 'react-i18next';
import GenericTablePage from '../components/GenericTablePage';
import { GridColDef } from '@mui/x-data-grid';

const BranchesPage: React.FC = () => {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    { field: 'name', headerName: t('branches.name'), flex: 1, minWidth: 200 },
    { field: 'phones', headerName: t('branches.phones'), flex: 1, minWidth: 200 },
  ];

  const fields = [
    { name: 'name', label: t('branches.name'), type: 'text' as const, required: true, width: 'half' as const },
    { name: 'phones', label: t('branches.phones'), type: 'text' as const, width: 'half' as const },
    { name: 'details', label: t('branches.details'), type: 'textarea' as const, width: 'full' as const },
  ];

  return (
    <GenericTablePage
      tableName="branches"
      title={t('branches.title')}
      columns={columns}
      fields={fields}
    />
  );
};

export default BranchesPage;
